import { createStore, applyMiddleware } from 'redux'
import  thunk from 'redux-thunk'
import { persistReducer } from 'redux-persist'
import storageSession from 'redux-persist/lib/storage/session'
import rootReducer from './reducers'

const persistConfig = {
  key: 'root',
  whitelist: ['language'],
  storage: storageSession,
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = createStore(persistedReducer, applyMiddleware(thunk));
